import { render, staticRenderFns } from "./review-result.vue?vue&type=template&id=31527f62&scoped=true"
import script from "./review-result.vue?vue&type=script&lang=js"
export * from "./review-result.vue?vue&type=script&lang=js"
import style0 from "./review-result.vue?vue&type=style&index=0&id=31527f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31527f62",
  null
  
)

export default component.exports